import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useState } from 'react'

export const usePurchaseProcessManager = () => {
    const statusUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchaseProcessStatus
    )
    const stageUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchaseProcessStage
    )
    const assigneeUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchaseProcessAssignee
    )
    const updateUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchaseProcess
    )
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const changeStatus = useCallback(
        async (
            id: string,
            status: PurchaseProcess['status']
        ): Promise<PurchaseProcess | null> => {
            setLoading(true)
            setError(null)
            try {
                return await statusUseCase.execute(id, status)
            } catch (e: any) {
                console.error(e)
                setError(
                    e?.response?.data?.message ?? 'Erro ao alterar o status'
                )
                return null
            } finally {
                setLoading(false)
            }
        },
        [statusUseCase]
    )

    const changeStage = useCallback(
        async (
            id: string,
            stageId: string
        ): Promise<PurchaseProcess | null> => {
            setLoading(true)
            setError(null)
            try {
                return await stageUseCase.execute(id, stageId)
            } catch (e: any) {
                console.error(e)
                setError(
                    e?.response?.data?.message ?? 'Erro ao alterar o estágio'
                )
                return null
            } finally {
                setLoading(false)
            }
        },
        [stageUseCase]
    )

    const changeAssignee = useCallback(
        async (
            id: string,
            /** null remove o responsável. */
            assignedTo: string | null
        ): Promise<PurchaseProcess | null> => {
            setLoading(true)
            setError(null)
            try {
                return await assigneeUseCase.execute(id, assignedTo ?? '')
            } catch (e: any) {
                console.error(e)
                setError(
                    e?.response?.data?.message ??
                        'Erro ao alterar o responsável'
                )
                return null
            } finally {
                setLoading(false)
            }
        },
        [assigneeUseCase]
    )

    const updateTitle = useCallback(
        async (id: string, title: string): Promise<PurchaseProcess | null> => {
            setLoading(true)
            setError(null)
            try {
                return await updateUseCase.execute(id, { title })
            } catch (e: any) {
                console.error(e)
                setError(
                    e?.response?.data?.message ?? 'Erro ao alterar o título'
                )
                return null
            } finally {
                setLoading(false)
            }
        },
        [updateUseCase]
    )

    return {
        changeStatus,
        updateTitle,
        changeStage,
        changeAssignee,
        loading,
        error,
    }
}
